import type { ButtonConfig } from '../../declare'
import { useContext } from 'react'
import { Popconfirm } from 'antd'
import { EasyIcon, ListTableContext, postMsg } from 'src/components'
import { appStore } from 'src/stores'
import { $api } from 'src/plugins'
import { initFilter } from 'src/utils/common'

type Props = {
  config: ButtonConfig
}

const CustomEvtBtn = (props: Props) => {
  const table = useContext(ListTableContext)

  const handleDelete = () => {
    const { API_URL } = props.config
    if (!API_URL) {
      postMsg('未配置API接口', 'error')
      return
    }
    const { __RECORD__: record } = props.config
    const { OrgId } = appStore.current.headers
    const payload = initFilter({ OrgId, Keyword: record?.ID })

    $api['app/getDataByPost'](payload,
      { url: API_URL }
    ).then((res: any) => {
      if (res) {
        table.reload()
        postMsg('操作成功')
      }
    })
  }

  const { __RENDER_SLOT__: renderSlot, LABEL, ICON, OP_CONF_PROMPT } = props.config
  return (
    <Popconfirm
      title={`${OP_CONF_PROMPT || '是否确认执行？'}`}
      placement='topLeft'
      onConfirm={handleDelete}
      getPopupContainer={() => document.getElementsByClassName(table.uniqClass)[0] as HTMLElement}
    >
      {
        renderSlot?.(props.config) ?? (
          <span title={LABEL}>
            <EasyIcon type={ICON} defaultIcon='CloudSyncOutlined' className='fz-16' />
            <span className='pd-l4'>{LABEL}</span>
          </span>
        )
      }
    </Popconfirm>
  )
}

export default CustomEvtBtn